type Crumb = {
  label: string;
  href?: string;
};

type BreadcrumbsProps = {
  crumbs: readonly Crumb[];
};

export function Breadcrumbs({ crumbs }: BreadcrumbsProps) {
  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol>
        {crumbs.map((crumb) => (
          <li key={crumb.label} aria-current={crumb.href ? undefined : "page"}>
            {crumb.href ? <a href={crumb.href}>{crumb.label}</a> : <span>{crumb.label}</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}
